
import BiorecipeAPP from "../components/BiorecipeApp";

export default function Biorecipe() {
 return <BiorecipeAPP />;
}
